// based on ../ui/components/zoom.js
import VDOM from "../ui/vdom/vdom";

import { makeType, initLog } from "../ui/core/base";

import UI from "../ui/core/ui";

import { getWith, maybe, first, guard } from "../ui/core/functions";

import { Stream } from "../ui/core/dispatcher-flyd";
import { modelChanged } from "../ui/components/common";

const imageExtension = (url) => (url.includes(".png") ? ".png" : ".jpg");
const imageType = (url) => (url.includes(".png") ? "image/png" : "image/jpg");

const updateElement = (content, elem, attrs) => {
  if (content == null) {
    content = " ";
  }
  elem.content = content;
  if (attrs != null) {
    elem.attrs = Object.assign(elem.attrs, attrs);
  }
  elem.rerender();
};

const updateObject = (old, update) => {
  return {
    ...old,
    ...update,
  };
};

const largestImage = (c) =>
  maybe((bgset) => {
    const url = first(bgset.split(",").reverse()).split(" ")[0];
    return `https:${url}`;
    //   console.warn (`url: ${url}`)

    // return bgset.split(",").reduce((last, cur) => {
    //     const parts = cur.split(" ")
    //     const url = parts[0]
    //     const width = parts[1]
    //     const heigh = parts[2]
    //   console.warn(`cur: ${width} ${cur}`);
    //   if (cur.includes("2160x") == true) {
    //     console.warn(`matched: ${cur}`);
    //     return `https:${cur.split(" ")[0]}`;
    //   } else {
    //     return last;
    //   }
    // });
  })(c.dataset.bgset);

const proto = {
  name: "Zoom",

  initLog,

  init() {
    return {
      url: null,
      title: null,
      subtitle: null,
      captionUrl: null,
    };
  },

  view(model) {
    guard()
      .where(window.matchMedia("(min-width: 48em)").matches)
      .do(() => {
        const popup = getWith("target", "behaviors", "Popup")(this);
        maybe((popup, zoomImage, url) => {
          // if (url.includes("_square")) {
          //   // zoomImage.attrs.class =
          //   //   "zoom-window_2 stoned bg-cover aspect-3_11 aspect-70 ";
          //   zoomImage.attrs.class = "zoom-window high bg-contain";
          // } else if (url.includes("gallery_cover")) {
          //   zoomImage.attrs.class = "zoom-window high bg-cover";
          // } else {
          //   zoomImage.attrs.class = "zoom-window high bg-contain";
          // }
          // zoomImage.attrs.class = "zoom-window high bg-contain";

          zoomImage.style.backgroundImage = `url('${url}')`;
          zoomImage.rerender();

          const title = [model.title, model.subtitle]
            .filter((r) => r != null)
            .join(" · ");

          // TODO: restore dark/light image backgrounds; add background color

          // const classes = model.darkImage === true ? "ta-r white italic fs-16 mr-xl1 o-5a o-9" : "ta-r fc-b-8 italic fs-16 mr-xl1 o-5"
          // if (model.darkImage === true) {
          //   updateElement(title, this.zoomTitle, { class: "ta-r white italic fs-16 mr-xl1 o-5" });
          // } else {
          //   updateElement(title, this.zoomTitle, { class: "ta-r fc-b-8 italic fs-16 mr-xl1 o-5" });
          // }

          if (
            model.captionUrl == null ||
            model.captionUrl.includes("gallery")
          ) {
            updateElement(title, this.zoomAnchor, {
              href: null,
              // class: classes
            });
          } else {
            updateElement(title, this.zoomAnchor, {
              href: model.captionUrl,
              // class: classes
            });
          }
          // updateElement(model.subtitle, this.zoomSubTitle)

          popup.show("zoomed");
        })(popup, this.zoomImage, model.url);

        return model;
      });
  },

  update(msg, model) {
    model = {
      ...model,
    };

    if (msg.type === "click") {
      model.url = null;
      model.title = null;

      const target = event.target.hasRole("open")
        ? event.target.getParent()
        : event.target;

      const image = first(
        [...target.querySelectorAll(`[data-bgset]`)].concat([target])
      );

      const url = largestImage(image);
      const validTitle = (t) => (t === "None" ? null : t);

      const title = image.dataset.fullTitle
        ? image.dataset.fullTitle
        : image.dataset.title
        ? image.dataset.title
        : null;

      model = updateObject(model, {
        url: "" ? null : url,
        title: validTitle(title),
        subtitle: validTitle(image.dataset.subtitle),
        captionUrl: image.dataset.url ? image.dataset.url : null,
        darkImage: target.dataset.darkImage === "true",
      });
    }

    return model;
  },

  initialize(dom) {
    this.dom = dom;
    this.initLog();

    this.dom = dom;

    this.controls = dom.findByRole("open");
    this.target = document.findByRole("popup")[0];
    this.vdom();

    let currentModel = this.init();

    this.eventStream = new Stream();
    this.eventStream.map((msg) => {
      let model = {
        ...currentModel,
      };
      model.title = null;

      model = this.update(msg, model);
      if (modelChanged(currentModel, model)) {
        model = this.view(model);
      }
      currentModel = model;
    });

    this.view(currentModel);

    const glob = this;
    this.controls.forEach((t) => t.addEvent("click", glob.eventStream.stream));

    guard()
      .where(window.matchMedia("(min-width: 48em)").matches)
      .do(() => {
        this.preloadImages();
      });
  },

  preloadImages() {
    this.controls.forEach((c) => {
      maybe((bgset) => {
        // const url = bgset.split(",").reduce((last, cur) => {
        //   this.log.warn(`cur: ${cur}`);
        //   if (cur.includes("2160x") == true) {
        //     this.log.warn(`matched: ${cur}`);
        //     return `https:${cur.split(" ")[0]}`;
        //   } else {
        //     return last;
        //   }
        // });
        const url = largestImage(c);
        if (c != null) {
          const vdom = new VDOM.Node();
          vdom.appendElement("link", {
            rel: "prefetch",
            as: "image",
            href: url,
            type: imageType(url),
          });
          vdom.render();
          vdom.mount(c);
        }
      })(c.dataset.bgset);
    });
  },

  vdom() {
    const template = `
    <section class="h-fill g_zoom_window large theme1 " style="debug1">
      <div class="g_zoom_image relative bg-gray1 bg-b-3 debug1" style="">
        <div class="fill hv-center hfill">
            <div data-role="zoomImage" class="bg-contain bg-center hfill vfill"></div>
        </div>
      </div>

      <div class="g_zoom_text flex justify-between debug1">
        <div class="grid theme1">

        </div>

        <div class="grid content-center debug1">
          <header class="mb-l mr-l fill lh">
            <h1 data-role="zoomTitle" class="ta-r fc-b-8 italic fs-16 mr-xl o-5 debug1 mb-4"></h1>
            <h2 data-role="zoomSubtitle" class="ta-r fc-b-8 italic fs-16 mr-xl o-5 mt1 debug1"></h2>
          </header>
        </div>
      </div>
    </section>
    `;

    const vdom = VDOM.importHTML(template);

    // const vdom = new VDOM.Node();

    // const s = vdom.appendElement("section", {
    //   class: "h-fill g_zoom_window",
    // });

    // this.zoomImage = s.appendElement("div");
    // // this.zoomImage = s.appendElement("div");
    this.zoomImage = first(vdom.findByRole("zoomImage"));
    this.zoomTitle = first(vdom.findByRole("zoomTitle"));
    this.zoomAnchor = this.zoomTitle.appendElement("a");
    this.zoomSubTitle = first(vdom.findByRole("zoomSubTitle"));

    vdom.render();
    vdom.mount(this.target);
  },

  vdom1() {
    const vdom = new VDOM.Node();

    const s = vdom.appendElement("section", {
      class: "fill h-fill bg-w bordered",
    });

    this.zoomImage = s.appendElement("div");

    const h = s.appendElement("header", {
      // class: "lh-s bottom-center1 absolute bottom-center-right w-801 debug1 mb-xxl ht-4 stoned",
      // class: "lh-s bottom-left w-80 debug1 mb mb-xl-ns ht-4 stoned",
      class: "lh-s bottom-center w-80 debug1 mb mb-xl-ns ht-4 stoned",
    });

    this.zoomTitle = h.appendElement("h1", {
      class: "ta-r fc-b-8 italic fs-16 mr-xl1 o-5a",
    });
    this.zoomAnchor = this.zoomTitle.appendElement("a");

    this.zoomSubTitle = h.appendElement("h2", {
      class: "ta-r fc-b-8 italic fs-16 mr-xl1 o-5a",
    });

    vdom.render();
    vdom.mount(this.target);
  },
};

const Zoom = makeType(proto);

UI.register("zoom", Zoom);
